function stripHtml(html) {
  return html?.replace(/<[^>]*>?/gm, "")
}

export default stripHtml
